/* @flow */

export const customerLayer26Order = [
  { kind: '1', subKind: 1 },
  { kind: '1', subKind: 2 },
  { kind: '3', subKind: 1 },
  { kind: '0', subKind: 1 },
  { kind: '1', subKind: 3 },
  { kind: '2', subKind: 1 },
  { kind: '0', subKind: 2 },
  { kind: '1', subKind: 4 },
  { kind: '0', subKind: 3 },
  { kind: '3', subKind: 2 },
  { kind: '0', subKind: 4 },
  { kind: '1', subKind: 5 },
  { kind: '0', subKind: 5 },
  { kind: '3', subKind: 3 },
  { kind: '0', subKind: 6 },
  { kind: '1', subKind: 6 },
  { kind: '2', subKind: 2 },
  { kind: '0', subKind: 7 },
];

export const customerLayer5Order = [
  { kind: '0', subKind: 7 },
  { kind: '2', subKind: 2 },
  { kind: '1', subKind: 6 },
  { kind: '0', subKind: 6 },
  { kind: '3', subKind: 3 },
  { kind: '0', subKind: 5 },
  { kind: '1', subKind: 5 },
  { kind: '0', subKind: 4 },
  { kind: '3', subKind: 2 },
  { kind: '0', subKind: 3 },
  { kind: '1', subKind: 4 },
  { kind: '0', subKind: 2 },
  { kind: '2', subKind: 1 },
  { kind: '1', subKind: 3 },
  { kind: '0', subKind: 1 },
  { kind: '3', subKind: 1 },
  { kind: '1', subKind: 2 },
  { kind: '1', subKind: 1 },
];

export const WIDTH = 864;
export const HEIGHT = 476;
